import { PTagDismissible } from "@porsche-design-system/components-react"

interface TagListProps {
	label: string
	onDismiss: (value: string, index: number) => void
	values: string[] | undefined
}

export const TagList = ({ label, onDismiss, values }: TagListProps) =>
	values?.map((value, index) => (
		<PTagDismissible key={`${label}-${value}`} label={label} onClick={() => onDismiss(value, index)}>
			{value}
		</PTagDismissible>
	))
